import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { fleetview } from 'services/fleetview'

import { Home } from 'modules/App'
import { AuthProvider } from 'modules/Auth/components/AuthProvider'

import { LoginRoute } from 'components/LoginRoute'
import { PrivateRoute } from 'components/PrivateRoute'
import { ConfirmationDialogProvider } from 'components/ConfirmationDialog'
import { PasswordReset } from 'components/PasswordReset'

function App() {
  return (
    <div className="App">
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <AuthProvider axiosInstances={[fleetview]}>
          <ConfirmationDialogProvider>
            <Routes>
              <Route path="/login" element={<LoginRoute />} />
              <Route path="/reset-password" element={<PasswordReset />} />
              <Route
                path="/*"
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />
            </Routes>
          </ConfirmationDialogProvider>
        </AuthProvider>
      </BrowserRouter>
      <ToastContainer className={'-mr-1'} autoClose={2500} />
    </div>
  )
}

export default App
